import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Loader from 'cccisd-loader';
import useQuery from '../../../useQuery';
import componentsQuery from './componentsQuery.graphql';
import ComponentsChart from './components/ComponentsChartBar';
import _round from 'lodash/round';
import _mean from 'lodash/mean';
import style from './style.css';

const FidelityComponentsChart = props => {
    const [hidden, setHidden] = useState(true);
    const { title, description, show, chart } = props.settings;
    const { isPreview, query } = props;

    const [data, loading] = useQuery({
        query: isPreview ? componentsQuery : query,
        variables: props.filters,
    });

    // See overallFidelityChart for comments
    useEffect(() => {
        setTimeout(() => {
            setHidden(false);
        }, 300);
    }, []);

    if (loading) {
        return <Loader loading />;
    }

    const chartData = props.convertDataStructure(data);

    return (
        <>
            {show && (
                <div className={style.wrapper}>
                    <div>
                        <span style={{ fontWeight: 'bold', fontSize: '1.5em' }}>{title}</span>
                    </div>
                    <div>{description}</div>
                    {hidden ? <div /> : <ComponentsChart data={chartData} settings={chart} />}
                </div>
            )}
        </>
    );
};

FidelityComponentsChart.propTypes = {
    settings: PropTypes.object,
    isPreview: PropTypes.bool,
    filters: PropTypes.object,
};

FidelityComponentsChart.defaultProps = {
    filters: {},
    convertDataStructure: data => {
        // console.log(data);
        let convertedData = [];

        if (data && data.groups.treatmentGroupList.length > 0) {
            const sessionScores = {
                leadership: [[], [], [], [], []],
                foundational: [[], [], [], [], []],
            };
            data.groups.treatmentGroupList.forEach(tg => {
                const APL = tg.childRoles.metricspawn.assignmentProgressList;

                for (let i = 0; i < 5; i++) {
                    const session = APL.find(s => s.deployment.label === `Session ${i + 1}`);
                    if (session) {
                        const leadershipScore = session.devTags.FidelityLeadershipScore;
                        if (leadershipScore !== null) {
                            sessionScores.leadership[i].push(Number(leadershipScore));
                        }
                        const foundationalScore = session.devTags.FidelityFoundationlElementsScore;
                        if (foundationalScore !== null) {
                            sessionScores.foundational[i].push(Number(foundationalScore));
                        }
                    }
                }
            });

            const getAdherenceData = group => {
                let componentsData = {
                    metric: group === 'leadership' ? 'Leadership & Group Process' : 'Foundational Elements',
                };
                for (let i = 0; i <= 4; i++) {
                    componentsData[`Session ${i + 1}`] = _round(_mean(sessionScores[group][i]), 1);
                }
                // console.log(componentsData);
                return componentsData;
            };
            convertedData = [getAdherenceData('foundational'), getAdherenceData('leadership')];
        } else {
            convertedData = [
                {
                    metric: 'Foundational Elements',
                    'Session 1': 4.3,
                    'Session 2': 3.13,
                    'Session 3': 4.5,
                    'Session 4': 4.1,
                    'Session 5': 3.56,
                },
                {
                    metric: 'Leadership & Group Process',
                    'Session 1': 4.6,
                    'Session 2': 4.3,
                    'Session 3': 4.1,
                    'Session 4': 4.3,
                    'Session 5': 4.5,
                },
            ];
        }
        // console.log({ convertedData });
        return convertedData;
    },
};

export default FidelityComponentsChart;
